import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/cyberswarm/cyberswarm-client.tsx");
